import { useState } from 'react';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Maria Silva',
      location: 'Blumenau - SC',
      event: 'Casamento',
      text: 'DJ Jean foi sensacional no nosso casamento! A iluminação estava perfeita e todos os convidados elogiaram a qualidade do som. Super profissional e pontual!',
    },
    {
      name: 'Carlos Rodrigues',
      location: 'Indaial - SC',
      event: 'Aniversário 50 anos',
      text: 'Contratei o DJ Jean para minha festa de 50 anos e foi um sucesso total! Música de qualidade, interação excelente com os convidados. Recomendo!',
    },
    {
      name: 'Ana Paula Oliveira',
      location: 'Timbó - SC',
      event: 'Debutante',
      text: 'A festa de 15 anos da minha filha ficou inesquecível! DJ Jean tocou todos os hits que pedimos e os efeitos especiais foram incríveis. Muito obrigada!',
    },
    {
      name: 'Roberto Santos',
      location: 'Gaspar - SC',
      event: 'Evento Corporativo',
      text: 'Excelente profissional! Contratamos para nossa confraternização de fim de ano e superou as expectativas. Som perfeito e muita animação!',
    },
    {
      name: 'Juliana Costa',
      location: 'Blumenau - SC',
      event: 'Casamento',
      text: 'DJ Jean foi fundamental para o sucesso do nosso casamento! Desde a cerimônia até a festa, tudo perfeito. Atendimento impecável desde o primeiro contato!',
    },
    {
      name: 'Pedro Müller',
      location: 'Indaial - SC',
      event: 'Aniversário',
      text: 'Festa incrível! DJ Jean soube ler muito bem o público e tocou exatamente o que todos queriam ouvir. Equipamentos de primeira qualidade!',
    },
    {
      name: 'Fernanda Becker',
      location: 'Timbó - SC',
      event: 'Formatura',
      text: 'Contratamos para nossa formatura e foi perfeito! DJ Jean é muito atencioso, profissional e tem um equipamento top. Super recomendo!',
    },
    {
      name: 'Marcos Zimmermann',
      location: 'Gaspar - SC',
      event: 'Inauguração',
      text: 'DJ Jean prestou um excelente serviço na inauguração da nossa loja. Som potente, locução profissional e muita qualidade. Parabéns pelo trabalho!',
    },
  ];

  const [rating, setRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const textarea = form.querySelector('textarea[name="depoimento"]') as HTMLTextAreaElement;
    if (textarea && textarea.value.length > 500) return;

    setSubmitting(true);
    const formData = new URLSearchParams();
    const elements = form.elements as HTMLFormControlsCollection;
    Array.from(elements).forEach((el) => {
      const input = el as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
      if (input.name) formData.append(input.name, input.value);
    });
    formData.append('avaliacao', String(rating));

    try {
      await fetch('https://readdy.ai/api/form/d786d7b86jhav3jpf3s0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      form.reset();
      setRating(5);
      setCharCount(0);
    } catch {
      // silent
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="depoimentos" className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Depoimentos</h2>
          <p className="text-base md:text-lg text-gray-600">Veja o que nossos clientes dizem sobre nosso trabalho</p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 p-4 rounded-xl shadow-lg">
              <div className="flex items-center mb-3">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center mr-3">
                  <i className="ri-user-3-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-800 text-sm">{testimonial.name}</h4>
                  <p className="text-xs text-gray-600">{testimonial.location}</p>
                </div>
              </div>
              
              <div className="mb-3">
                <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                  {testimonial.event}
                </span>
              </div>
              
              <p className="text-gray-700 italic text-xs">{testimonial.text}</p>
              
              <div className="flex text-yellow-400 mt-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Formulário de depoimento */}
        <div className="mt-16 max-w-2xl mx-auto">
          <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 border border-gray-200">
            <div className="text-center mb-6">
              <div className="w-14 h-14 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-chat-heart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-1">Deixe seu Depoimento</h3>
              <p className="text-gray-500 text-sm">Conte como foi sua experiência com o DJ Jean!</p>
            </div>

            {submitted ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-green-500 text-3xl"></i>
                </div>
                <h4 className="text-xl font-bold text-gray-800 mb-2">Obrigado pelo depoimento!</h4>
                <p className="text-gray-500 text-sm mb-4">Sua avaliação foi enviada com sucesso. Agradecemos muito!</p>
                <button
                  onClick={() => setSubmitted(false)}
                  className="text-orange-500 hover:text-orange-600 font-semibold text-sm cursor-pointer transition-colors"
                >
                  Enviar outro depoimento
                </button>
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubmit}
                className="space-y-4"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                      Nome completo <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="nome"
                      required
                      placeholder="Seu nome"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-1">
                      Cidade <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="cidade"
                      required
                      placeholder="Ex: Blumenau - SC"
                      className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Tipo de evento <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="tipo_evento"
                    required
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white cursor-pointer"
                  >
                    <option value="">Selecione o tipo de evento</option>
                    <option value="Casamento">Casamento</option>
                    <option value="Aniversário">Aniversário</option>
                    <option value="Debutante">Debutante (15 anos)</option>
                    <option value="Formatura">Formatura</option>
                    <option value="Evento Corporativo">Evento Corporativo</option>
                    <option value="Inauguração">Inauguração</option>
                    <option value="Festa Infantil">Festa Infantil</option>
                    <option value="Outro">Outro</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Sua avaliação <span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <button
                        key={star}
                        type="button"
                        onClick={() => setRating(star)}
                        onMouseEnter={() => setHoverRating(star)}
                        onMouseLeave={() => setHoverRating(0)}
                        className="cursor-pointer transition-transform hover:scale-110"
                      >
                        {(hoverRating || rating) >= star ? (
                          <i className="ri-star-fill text-2xl text-yellow-400"></i>
                        ) : (
                          <i className="ri-star-line text-2xl text-gray-300"></i>
                        )}
                      </button>
                    ))}
                    <span className="ml-2 text-sm text-gray-500">
                      {rating === 1 && 'Ruim'}
                      {rating === 2 && 'Regular'}
                      {rating === 3 && 'Bom'}
                      {rating === 4 && 'Muito bom'}
                      {rating === 5 && 'Excelente!'}
                    </span>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Seu depoimento <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    name="depoimento"
                    required
                    rows={4}
                    maxLength={500}
                    placeholder="Conte como foi sua experiência com o DJ Jean..."
                    onChange={(e) => setCharCount(e.target.value.length)}
                    className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-orange-400 bg-white resize-none"
                  />
                  <p className={`text-xs mt-1 text-right ${charCount > 480 ? 'text-red-500' : 'text-gray-400'}`}>
                    {charCount}/500 caracteres
                  </p>
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-white font-bold py-3 rounded-lg transition-all transform hover:scale-[1.02] cursor-pointer whitespace-nowrap flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {submitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin"></i>
                      Enviando...
                    </>
                  ) : (
                    <>
                      <i className="ri-send-plane-line"></i>
                      Enviar Depoimento
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}